import { IonCol, IonRow, IonText } from "@ionic/react";

import "./WhyMFP.css";

const WHY_CARDS: { title: string; text: string }[] = [
  {
    text: "Access your data from anywhere, at any time, ensuring you're always informed about your aircraft's status.",
    title: "Cloud-Based Accessibility",
  },
  {
    text: " Optimize engine maintenance and overhaul costs by accurately following OEM recommendations.",
    title: "Cost Savings",
  },
  {
    text: "Anticipate maintenance needs and reduce unexpected downtime with our intelligent component tracking.",
    title: "Predictive Maintenance",
  },
  {
    text: " From flight planning to maintenance logging, manage all aspects of your aircraft operations in one platform.",
    title: "Comprehensive Management",
  },
];

function WhyMyFirePlane({ id }: { id?: string }) {
  return (
    <IonRow className="wmfp-container" id={id}>
      <IonCol>
        <IonRow>
          <IonText color="marketing-gold">
            <h1 className=" ion-no-padding">Why MyFirePlane?</h1>
          </IonText>
        </IonRow>
        <IonRow className="wmfp-blocks">
          {WHY_CARDS.map((card, idx) => (
            <IonCol key={idx} sizeMd="6" sizeXs="12">
              <h2 className="sub-title ion-no-padding">{card.title}</h2>
              <IonText>{card.text}</IonText>
            </IonCol>
          ))}
        </IonRow>
      </IonCol>
    </IonRow>
  );
}
export { WhyMyFirePlane };
